import invert from 'invert-color';
import rgba from 'rgba-convert';

class FormatService {
  getPercent(voteCount = 0, totalVoteCount = 0) {
    const percent = Number(((voteCount * 100) / totalVoteCount).toFixed(0));
    return isNaN(percent) ? 0 : percent;
  }
  invertColor(color) {
    return invert(rgba(color), true);
  }
  fontSize(text) {
    if (text.length <= 70) {
      return '3vw';
    } else if (text.length <= 210) {
      return '45px';
    }
    return '26px';
  }
}
export default new FormatService();
